import { render, staticRenderFns } from "./Competition.vue?vue&type=template&id=8059e080&scoped=true&"
import script from "./Competition.vue?vue&type=script&lang=js&"
export * from "./Competition.vue?vue&type=script&lang=js&"
import style0 from "./Competition.vue?vue&type=style&index=0&id=8059e080&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8059e080",
  null
  
)

export default component.exports